const pzlzClassperson = {
  state: {
      userRole: { // 用户角色判断
        patrolStaff: 'test1', // 廉政工作人员
        IncorruptibleStaff: 'test2', // 巡视工作人员
        daAdmin: 'daAdmin' //档案管理员
      },
      checkedBranch: {
          branchCode: '', // 组织树的branchCode
          innerCode: '', // 组织树的innerCode
          branchName: '', // 组织树的名称
          abbreviation: '', // 简称
          branchType: '' // 节点类型
      },
      tourTableList: [],
      questionNum: [],
      inspectionNum: [],
      infoNum:[],
      queryTourListData: {},
      treeSelect:'',  //左侧树选中的内容
      treeOid:'',   //左侧树的id
      status:'',   //二级菜单控制
      feedbackTime:'', //反馈日期
      inspectionEntityid:'',//巡视id
      isOldData:'',//是否历史巡视数据
      inspectionStartTime:'',//巡视开始时间
      inspectionEndTime:'',//巡视结束时间
      tableData: [], //整改任务数据
      routerFlag:false,  //路由跳转的标识
      auditId:'',   //工作桌面点击查看方案的id
      upAuditId:'',   //整改报告审核id
      batchId:'',   //呈批单页面id
      inspectedUnitName:'',   //被巡视单位名称
      inspectedUnitCode:'',//被巡视单位编码
      routerRow:{}, //工作桌面整改方案调转行数据
      rowStatus:'', //工作桌面跳转的status
      upAuditIdOpen:'', //整改公开新建呈批要用的id
      isAuditOpen:'',   //整改情况公开审核的状态
      inspectionEntity:{},  //届次轮次
      wpsFile:{},   //永中wps的文件内容
      questionLabelOption:[], //问题标签分类
      societyOpen:'', // 社会公开的二次提交
      partyOpen:'', // 党内公开的二次提交
      inspectedStatus: null // 巡视单位签收状态
  },
  mutations: {
    setWPSFile(state, value) {
      state.wpsFile = value
    },
    setQuestionLabelOptions(state, value) {
      state.questionLabelOption = value
    },
    setInspectionEntity(state, value) {
      state.inspectionEntity = value
    },
    setSocietyOpen(state, value) {
      state.societyOpen = value
    },
    setPartyOpen(state, value) {
      state.partyOpen = value
    },
    setIsAuditOpen(state, value) {
      state.isAuditOpen = value
    },
    setUpAuditIdOpen(state, value) {
      state.upAuditIdOpen = value
    },
    setRowStatus(state, value) {
      state.rowStatus = value
    },
    setRouterRow(state, value) {
      state.routerRow = value
    },
    setInspectedUnitName(state, value) {
      state.inspectedUnitName = value
    },
      setBatchId(state, value) {
        state.batchId = value
      },
      setUpAuditId(state, value) {
        state.upAuditId = value
      },
      setAuditId(state, value) {
        state.auditId = value
      },
      setRouterFlag(state, value) {
        state.routerFlag = value
      },
      setTableData(state, value) {
        state.tableData = value
      },
      setFeedbackTime(state, value) {
        state.feedbackTime = value
      },
      setInspectedUnitCode(state, value) {
        state.inspectedUnitCode = value
      },
      setInspectionEntityid(state, value) {
          state.inspectionEntityid = value
        },
      setInspectionStartTime(state, value) {
        state.inspectionStartTime = value
      },
      setInspectionEndTime(state, value) {
        state.inspectionEndTime = value
      },
      setStatus(state, value) {
        state.status = value
      },
      setTreeOid(state, value) {
        state.treeOid = value
      },
      setTreeSelect(state, value) {
        state.treeSelect = value
      },
      setTourTableList(state, value) {
          state.tourTableList = value
      },
      setQuestionNum(state, value) {
          state.questionNum = value
      },
      setInspectionNum(state, value) {
          state.inspectionNum = value
      },
      setInfoNum(state, value) {
          state.infoNum = value
      },
      setQueryTourListData(state, value) {
          state.queryTourListData = value
      },
      setIsOldData(state, value) {
          state.isOldData = value
      },
      setCheckedBranch(state, value) {
          state.checkedBranch.branchCode = value.branchCode
          state.checkedBranch.innerCode = value.innerCode
          state.checkedBranch.branchName = value.branchName
          state.checkedBranch.unitFunctional = value.unitFunctional
          state.checkedBranch.unitType = value.unitType
          state.checkedBranch.address = value.address
          state.checkedBranch.abbreviation = value.abbreviation
          state.checkedBranch.branchType = value.branchType
      },
      setInspectedStatus(state, value) {
        state.inspectedStatus = value
      }
  },

}
export default pzlzClassperson



// WEBPACK FOOTER //
// ./src/store/modules/pzlzClassperson.js